// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { FacebookAuthProvider, getAuth, signInWithPopup, signInWithRedirect } from "firebase/auth";

const firebaseConfig = {

  apiKey: "AIzaSyBNbpRopMy1qFBYMxyVuB05-mtlTKgIFhY",

  authDomain: "silken-period-444312-f3.firebaseapp.com",

  projectId: "silken-period-444312-f3",

  storageBucket: "silken-period-444312-f3.firebasestorage.app",

  messagingSenderId: "479780104538",

  appId: "1:479780104538:web:c532d0d2b5d7cb45052b63",

  measurementId: "G-M8KQ43HHT1"

};

console.log("🚀 ~ firebaseConfig.projectId:", firebaseConfig.projectId)
const provider = new FacebookAuthProvider();

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth=getAuth(app)
export { app, analytics };

export const FacebookAuth = async () => {
  try {
    await signInWithRedirect(auth, provider);
  } catch (error) {
    console.error("Error with redirect sign-in:", error);
  }
};

